import script from "./CaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./CaseDetail.vue?vue&type=style&index=0&id=1b9d3040&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9d3040"]])

export default __exports__